import produce from 'immer'
import { assign } from 'lodash'

import { FETCH_USER_DETAILS, UPSERT_USER_DETAILS } from '../action-types'
import { USER_INITIAL_STATE } from '../initial-states'

const userReducer = (state = USER_INITIAL_STATE, action) => {
  switch (action.type) {
    case FETCH_USER_DETAILS.START:
      return produce(state, nextState =>
        assign(nextState, {
          isLoading: true,
          error: undefined,
          data: undefined,
        }),
      )

    case FETCH_USER_DETAILS.COMPLETE:
      return produce(state, nextState =>
        assign(nextState, {
          isLoading: false,
          error: undefined,
          data: action.payload.data.user,
        }),
      )

    case FETCH_USER_DETAILS.FAIL:
      return produce(state, nextState =>
        assign(nextState, {
          isLoading: false,
          error: action.error.message,
          data: undefined,
        }),
      )

    case FETCH_USER_DETAILS.CLEANUP:
      return { ...USER_INITIAL_STATE }

    case UPSERT_USER_DETAILS.START:
      return produce(state, nextState =>
        assign(nextState, {
          isLoading: true,
          error: undefined,
          data: nextState.data,
        }),
      )

    case UPSERT_USER_DETAILS.COMPLETE:
      return produce(state, nextState =>
        assign(nextState, {
          isLoading: false,
          error: undefined,
          data:
            action.payload.data?.createUser || action.payload.data?.updateUser,
        }),
      )

    case UPSERT_USER_DETAILS.FAIL:
      return produce(state, nextState =>
        assign(nextState, {
          isLoading: false,
          error: action.error.message,
          data: nextState.data,
        }),
      )

    default:
      return state
  }
}

export default userReducer
